import { call, put, takeEvery } from "redux-saga/effects"

//restapi end point
import * as constClass from "../../../common/constant/constantURL"
// Login Redux States
import { BULK_IMPORT_MIGRATION_DATA, FIELD_MAP_DATA, GET_CSV_FILE, GET_MIGRATION_IDS, GET_MIGRATION_STATUS, IMPORT_MIGRATION_DATA } from "./actionTypes"
import { bulkImportMigrationDataFailed, bulkImportMigrationDataSuccess, fieldMapDataFailed, fieldMapDataSuccess, getCsvFileFailed, getCsvFileSuccess, getMigrationIdsFailed, getMigrationIdsSuccess, getMigrationStatusFailed, getMigrationStatusSuccess, importMigrationDataFailed, importMigrationDataSuccess } from "./actions"


import {
  getCall, postCall
} from "../../../helpers/fakebackend_helper"




function* getCsvFileHandler(user) {
    try{
      
      var url;
     console.log(user)
     let type=user.payload
      if(type==="CANDIDATE")
      {
        
        url=constClass.REST_API_GET_CSV_FILE_CANDIDATE+"/sample";
      }
      else
      {
        url= constClass.REST_API_GET_CSV_FILE_JOB+"/sample";
      }
         const response = yield call(getCall, url)
       
     yield put(getCsvFileSuccess(response))
        
        
    }catch (error) {
        yield put(getCsvFileFailed(error))
      }
    
    }

    function* importMigrationDataHandler(data) {
        try{
          
          var url;
          
          let user=data.payload
          if(user.type==="JD")
          {
            
            url=constClass.REST_API_MIGRATION+"/JD/file";
          }
          else
          {
            url=constClass.REST_API_MIGRATION+"/RESUME/file";
          }
             const response = yield call(postCall, url,user.files)
           
         yield put(importMigrationDataSuccess(response))
            
            
        }catch (error) {
            yield put(importMigrationDataFailed(error))
          }
        
        }

        function* fieldMapDataHandler(data) {
          try{
            var url;
            let user=data.payload
            if(user.type==="JD")
            {
              
              url=constClass.REST_API_MIGRATION+"/JD";
            }
            else
            {
              url=constClass.REST_API_MIGRATION+"/RESUME";
            }
               const response = yield call(postCall, url,user.data)
             
           yield put(fieldMapDataSuccess(response))
              
              
          }catch (error) {
              yield put(fieldMapDataFailed(error))
            }
          
          }

          function* bulkImportMigrationDataHandler(data) {
            try{
              var url;
              let user=data.payload
              if(user.type==="JD")
              {
                
                url=constClass.REST_API_MIGRATION_DATA+"/JD";
              }
              else
              {
                url=constClass.REST_API_MIGRATION_DATA+"/RESUME";
              }
                 const response = yield call(postCall, url,user.data)
               
             yield put(bulkImportMigrationDataSuccess(response))
                
                
            }catch (error) {
                yield put(bulkImportMigrationDataFailed(error))
              }
            
            }

            function* getMigrationIdsHandler(data) {
              try{
                var url;
                let user=data.payload
                if(user.type==="JD")
                {
                  
                  url=constClass.REST_API_MIGRATION_STATUS+"/JD";
                }
                else
                {
                  url=constClass.REST_API_MIGRATION_STATUS+"/RESUME";
                }
                   const response = yield call(getCall, url)
                 
               yield put(getMigrationIdsSuccess(response))
                  
                  
              }catch (error) {
                  yield put(getMigrationIdsFailed(error))
                }
              
              }

              function* getMigrationStatusHandler(data) {
                try{
                 
                  let user=data.payload
                  
                   let url=constClass.REST_API_MIGRATION_STATUS+`/${user}/status`;
                  
                     const response = yield call(getCall, url)
                   
                 yield put(getMigrationStatusSuccess(response))
                    
                    
                }catch (error) {
                    yield put(getMigrationStatusFailed(error))
                  }
                
                }



function* migrationSaga() {
  yield takeEvery(GET_CSV_FILE, getCsvFileHandler)
  yield takeEvery(IMPORT_MIGRATION_DATA,importMigrationDataHandler)
  yield takeEvery(FIELD_MAP_DATA,fieldMapDataHandler)
  yield takeEvery(BULK_IMPORT_MIGRATION_DATA,bulkImportMigrationDataHandler)
  yield takeEvery(GET_MIGRATION_IDS,getMigrationIdsHandler)
  yield takeEvery(GET_MIGRATION_STATUS,getMigrationStatusHandler);
  
}

export default migrationSaga